// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33363":"f3414ffc","56524":"8655c9e3"}[chunkId] + ".chunk.css";
};